export var AlphabeticalOrderEnums;
(function (AlphabeticalOrderEnums) {
  AlphabeticalOrderEnums["LETTER_LINKS_SELECTOR"] = "js-letter-link";
  AlphabeticalOrderEnums["ACTIVE_CLASS_LINK"] = "l-children-categories-alphabetical-order__letter-link--active";
  AlphabeticalOrderEnums["MENU_SELECTOR"] = "js-sticky-alphabet";
  AlphabeticalOrderEnums["CLASS_STICKY_FIXED"] = "l-children-categories-alphabetical-order__nav--sticky";
  AlphabeticalOrderEnums["TOP_OBSERVER_ELEMENT"] = "js-top-limiter";
  AlphabeticalOrderEnums["BOTTOM_OBSERVER_ELEMENT"] = "o-linksNotice";
})(AlphabeticalOrderEnums || (AlphabeticalOrderEnums = {}));